var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"general-layout"},[_c('router-view',{staticClass:"view-container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }